import { render, staticRenderFns } from "./DialogOpenBtnItem.vue?vue&type=template&id=2294e202&scoped=true"
import script from "./DialogOpenBtnItem.vue?vue&type=script&lang=js"
export * from "./DialogOpenBtnItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2294e202",
  null
  
)

export default component.exports